export const init = () => {
  const eventConstants = AnalyticsConstants.trackers.customer.account.creation;
  // TRACKER 'ACCOUNT CREATION'
  const tracker = new AnalyticsTracker(eventConstants);

  // Account Creation
  const accountCreated = new AnalyticsQueueEvent(
    'accountCreated',
    tracker.defaultEvent()
  );
  accountCreated.trigger = 'click';
  accountCreated.domElement = '#create-button';
  accountCreated.options.action = 'AccountCreated';
  accountCreated.options.label = '';
  accountCreated.options.value = 1;
  tracker.addEvent(accountCreated);

  // Country Changed for e-mail or phone number
  const countryChanged = new AnalyticsClickEvent(
    'countryChanged',
    tracker.defaultEvent()
  );
  countryChanged.trigger = 'click';
  countryChanged.domContainer = '.tel-group__input .dropdown-menu';
  countryChanged.domElement = 'li:not(.selected)';
  countryChanged.options.action = 'CountryChanged';
  countryChanged.getLabel = function getLabel($element) {
    return $element.find('.lang-label').text();
  };
  countryChanged.options.value = 1;
  tracker.addEvent(countryChanged);

  CUBE.Analytics.trackers.add(tracker);

  // Send event for every input with wrong or empty value (idem for radio button not selected)
  $('#create-button').on('click', $element => {
    setTimeout(() => {
      $('.account-form__container div.form-group').each(function() {
        const $radioDiv = $(this).find('.radio')[0];
        const $checkboxDiv = $(this).find('.checkbox')[0];

        sendEventForInput(this, 'input');
        if ($radioDiv) sendEventForInput($radioDiv, 'radio');
        if ($checkboxDiv) sendEventForInput($checkboxDiv, 'checkbox');
      });
    }, 100);
  });

  // Send event if the $element contains an input (not hidden) with wrong or empty value (idem for radio button not selected)
  const sendEventForInput = function sendEventForInput($element, type) {
    if ($element && $element.classList.contains('has-error')) {
      const input = $($element).find('input[type!="hidden"]')[0];
      if (input) {
        const error = getInputErrorByType(input, type);
        cube.analytics.sendEvent(
          input,
          AnalyticsConstants.trackers.customer.account.creation.defaultEvent
            .type,
          AnalyticsConstants.trackers.customer.account.creation.defaultEvent
            .category,
          'Alert',
          error,
          1
        );
        return true;
      }
    }
    return false;
  };

  // Get the input error according to its type
  const getInputErrorByType = function getInputErrorByType(input, type) {
    let error = type !== 'input' || input.value === '' ? 'Empty - ' : 'Bad - ';
    if (type === 'input') error += input.id;
    else if (type === 'checkbox') error += input.name;
    else {
      // Get the radio button id without the name of the selected option
      error += input.id
        .split('-')
        .slice(1)
        .join('-');
    }
    return error;
  };

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/creation-tracker.js